import { Injectable } from '@angular/core';
import { Client, IMessage } from '@stomp/stompjs';
import { BehaviorSubject, of } from 'rxjs';
import { ADMIN_VOICES, ADMINISTRATION_VOICES, PRODUZIONE_VOICES, ROLES, VENDITORE_VOICES } from '../common/constants';
import * as SockJS from 'sockjs-client';
import { Utils } from '../classes/utils';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class WsService {
  disableItems = [
    "GRUPPI",
    "PREVENTIVI X",
    "PREVENTIVI GENERALI",
    "CARICO",
    "PRODUZIONE",
    "AUTISTI",
    "PERCENTUALI"
  ];
  private baseUrl: string = environment.apiUrl;

  private stompClient: Client;
  public myRole: string;

  private buttonsDisabledSubject = new BehaviorSubject<boolean>(false);
  buttonsDisabled$ = this.buttonsDisabledSubject.asObservable();

  private adminVoicesSubject = new BehaviorSubject<string[]>(ADMIN_VOICES);
  adminVoices$ = this.adminVoicesSubject.asObservable();

  private administratorVoicesSubject = new BehaviorSubject<string[]>(ADMINISTRATION_VOICES);
  administratorVoices$ = this.administratorVoicesSubject.asObservable();

  private venditoreVoicesSubject = new BehaviorSubject<string[]>(VENDITORE_VOICES);
  venditoreVoices$ = this.venditoreVoicesSubject.asObservable();

  private produzioneVoicesSubject = new BehaviorSubject<string[]>(PRODUZIONE_VOICES);
  produzioneVoices$ = this.produzioneVoicesSubject.asObservable();

  constructor(public utils : Utils,
    private httpClient: HttpClient
  ) {
    this.initializeWebSocketConnection();
  }

  filterVoices(voices: string[], disableItems: string[]): string[] {
    const disableSet = new Set(disableItems.map(item => item.trim().toUpperCase()));
    return voices.filter(voice => !disableSet.has(voice.trim().toUpperCase()));
  }

  getFilteredVoiceByRole(myRole: string) {
    if (myRole == "ADMIN") {
        return this.filterVoices(ADMIN_VOICES, this.disableItems);
    } else if (myRole == "AMMINISTRAZIONE") {
        return this.filterVoices(ADMINISTRATION_VOICES, this.disableItems);
    } else if (myRole == "VENDITORE-EI" || myRole == "VENDITORE") {
        return this.filterVoices(VENDITORE_VOICES, this.disableItems);
    } else if (myRole == "PRODUZIONE") {
        return this.filterVoices(PRODUZIONE_VOICES, this.disableItems);
    }

    return [];
  }
  initializeWebSocketConnection() {
    const url = environment.wsUrl
    this.stompClient = new Client({
      webSocketFactory: () => new SockJS(url),
    });

    this.stompClient.onConnect = (frame) => {
      console.log('Connesso:', frame);

      this.stompClient.subscribe('/topic/buttons', (message: IMessage) => {
        const command = message.body;
        if (command === 'DISABLE') {
          this.buttonsDisabledSubject.next(true);

          this.myRole = this.utils.getHighestRole();
          console.log("RUOLOOOOO", this.myRole)
          let filteredVoices: string[];

          if (this.myRole == "ADMIN") {
            filteredVoices = this.filterVoices(ADMIN_VOICES, this.disableItems);
            this.adminVoicesSubject.next(filteredVoices);
          } else if (this.myRole == "AMMINISTRAZIONE") {
            filteredVoices = this.filterVoices(ADMINISTRATION_VOICES, this.disableItems);
            this.administratorVoicesSubject.next(filteredVoices);
          } else if (this.myRole == "VENDITORE-EI" || this.myRole == "VENDITORE") {
            filteredVoices = this.filterVoices(VENDITORE_VOICES, this.disableItems);
            this.venditoreVoicesSubject.next(filteredVoices);
          } else if (this.myRole == "PRODUZIONE") {
            filteredVoices = this.filterVoices(PRODUZIONE_VOICES, this.disableItems);
            this.produzioneVoicesSubject.next(filteredVoices);
          }
          console.log('Ricevuto comando DISABLE. Lista aggiornata:', filteredVoices);
        } else if (command === 'ENABLE') {
          this.buttonsDisabledSubject.next(false);
          this.myRole = this.utils.getHighestRole();
          if (this.myRole == "ADMIN") {
            this.adminVoicesSubject.next(ADMIN_VOICES);
          } else if (this.myRole == "AMMINISTRAZIONE") {
            this.administratorVoicesSubject.next(ADMINISTRATION_VOICES);
          } else if (this.myRole == "VENDITORE-EI" || this.myRole == "VENDITORE") {
            this.venditoreVoicesSubject.next(VENDITORE_VOICES);
          } else if (this.myRole == "PRODUZIONE") {
            this.produzioneVoicesSubject.next(PRODUZIONE_VOICES);
          }
          console.log('Ricevuto comando ENABLE. Lista ripristinata:');
        }
      });
    };
    this.stompClient.activate();
  }

  getVoiceByRole(myRole: string) {
    return myRole == "ADMIN" ? ADMIN_VOICES
             : myRole == "AMMINISTRAZIONE" ? ADMINISTRATION_VOICES
             : (myRole == "VENDITORE-EI" || myRole == "VENDITORE") ? VENDITORE_VOICES
             : myRole == "PRODUZIONE" ? PRODUZIONE_VOICES : [];
  }

  enableDisableButtons(isEnabled: boolean) {
    console.log('Abilita bottoni: ', isEnabled)
    const apiUrl = `${this.baseUrl}${isEnabled ? 'enable-buttons' : 'disable-buttons' }`;

    return this.httpClient.get<any>(apiUrl);
  }

  checkButtonsStatus() {
    const apiUrl = `${this.baseUrl}check-buttons-status`;

    return this.httpClient.get<any>(apiUrl);
  }

}
// http://localhost:9090/api/disable-buttons
// http://localhost:9090/api/enable-buttons
